import React, { FC, useMemo } from 'react'
import { isMobileOnly } from 'react-device-detect'

import { Recommendations, reduceProductEdgesToProductList } from '../../views'
import {
  CategoryList,
  Content,
  ProductList,
  CategoryBreadcrumbs,
  getListFromEdgesList
} from '../../components'

import { useStyle } from './category.styles'
import { CategoryPageProps } from './category.types'

export const CategoryPage: FC<CategoryPageProps> = ({ category: Parent }) => {
  const classes = useStyle({ mobile: isMobileOnly })
  const h1Preset = isMobileOnly ? 'h1Mobile' : 'h1'
  const titlePreset = isMobileOnly ? 'h2Mobile' : 'h2'
  const TopProducts = useMemo(
    () => reduceProductEdgesToProductList(Parent.topProducts.edges),
    [Parent]
  )

  const Categories = useMemo(
    () => getListFromEdgesList(Parent.children),
    [Parent]
  )

  const defaultDescription =
    'A new collection shot in the warmth of soft evening light. Discover elegant silhouettes, refined details.'
  const categoryBreadcrumb = { id: Parent.id, name: Parent.name }

  return (
    <Content justifyContent="flex-start">
      <CategoryBreadcrumbs
        active
        category={Parent}
        className={classes.breadcrumbs}
      />
      <CategoryList
        className={classes.categories}
        titlePreset={h1Preset}
        description={Parent.description || defaultDescription}
        data={Categories}
        title={Parent.name}
        categoryBreadcrumb={categoryBreadcrumb}
      />
      {TopProducts.length > 0 && (
        <ProductList
          carousel
          className={classes.products}
          title="TOP Products"
          titlePreset={titlePreset}
          titleTx="topProducts.title"
          data={TopProducts}
        />
      )}
      <Recommendations />
    </Content>
  )
}
